import { render, staticRenderFns } from "./Bundling.vue?vue&type=template&id=fa33ea6c"
import script from "./Bundling.vue?vue&type=script&lang=js"
export * from "./Bundling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports